import { ItemType } from "@enums/common.enum";

const ERROR_CANNOT_RETRIEVE_ITEM = 9046;

type ComposeItem = Office.MessageCompose | Office.AppointmentCompose;
type ReadItem = Office.MessageRead | Office.AppointmentRead;
type OutlookItem = ComposeItem | ReadItem;

export function getItemId(retrying: boolean = false): Promise<string | null> {
  const item = Office.context?.mailbox?.item as OutlookItem;
  const composeItem = item as ComposeItem;

  if (typeof composeItem?.getItemIdAsync === "function") {
    return new Promise((resolve) => {
      composeItem.getItemIdAsync((result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve(convertToRestId(result.value));
        } else {
          if (!retrying && composeItem && result.error?.code === ERROR_CANNOT_RETRIEVE_ITEM) {
            saveDraft((success) => {
              if (success) {
                getItemId(true)
                  .then(resolve)
                  .catch(() => resolve(null));
              } else {
                resolve(null);
              }
            });
            return;
          }
          resolve(null);
        }
      });
    });
  }

  const readItem = item as ReadItem;
  const itemId = readItem?.itemId ?? null;
  return Promise.resolve(convertToRestId(itemId));
}

export function getItemSubject(retrying: boolean = false): Promise<string | null> {
  const item = Office.context?.mailbox?.item as OutlookItem;
  const composeItem = item as ComposeItem;

  if (typeof composeItem?.subject?.getAsync === "function") {
    return new Promise((resolve) => {
      composeItem.subject.getAsync((result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve(result.value);
        } else {
          if (!retrying && composeItem && result.error?.code === ERROR_CANNOT_RETRIEVE_ITEM) {
            saveDraft((success) => {
              if (success) {
                getItemSubject(true)
                  .then(resolve)
                  .catch(() => resolve(null));
              } else {
                resolve(null);
              }
            });
            return;
          }
          resolve(null);
        }
      });
    });
  }

  const readItem = item as ReadItem;
  return Promise.resolve(readItem?.subject ?? null);
}

export async function getItemType(): Promise<ItemType> {
  const item = Office.context?.mailbox?.item as OutlookItem;
  const outlookItemType = item?.itemType as Office.MailboxEnums.ItemType | undefined;
  return outlookItemType === Office.MailboxEnums.ItemType.Message
    ? ItemType.EMAIL
    : ItemType.MEETING;
}

export function getComposeMode(): boolean {
  const item = Office.context?.mailbox?.item as ComposeItem | undefined;
  return typeof item?.saveAsync === "function";
}

export function saveDraft(callback: (success: boolean) => void): void {
  Office.context.mailbox.item.saveAsync((result) => {
    callback(result.status === Office.AsyncResultStatus.Succeeded);
  });
}

function convertToRestId(rawId: string | null | undefined): string | null {
  if (!rawId) return null;

  try {
    return Office.context.mailbox.convertToRestId(rawId, Office.MailboxEnums.RestVersion.v2_0);
  } catch {
    return rawId;
  }
}

export function getCalendarId(): Promise<string | null> {
  return Promise.resolve(null);
}
